export const DEFAULT_CONTEXT_VALUES = {
  API_BASE_URL: '',
  GOOGLE_AUTH_URL: '',
  FACEBOOK_AUTH_URL: '',
  UTAHID_AUTH_URL: '',
  AUTH_URL: ''
};
